import React from 'react';
import { Box } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CommentIcon from '@mui/icons-material/Comment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import moment from 'moment';
import { Button, Typography } from '@material-ui/core';

interface Log {
  _id: string;
  description: string;
  changeFrom: string | null;
  changeTo: string;
  recordId: string;
  createdBy: {
    _id: string;
    name: string | null;
    email: string | null;
  };
  recordType: string;
  createdAt: string;
}

interface OmsLogsProps {
  logsData: Log[];
}

// Function to determine the icon based on the description
const getIconForDescription = (description: string) => {
  const lowerCaseDescription = description.toLowerCase();
  if (lowerCaseDescription.includes('description'))
    return <DescriptionIcon sx={{ color: '#c22027' }} />;
  if (lowerCaseDescription.includes('organization'))
    return <DescriptionIcon sx={{ color: '#c22027' }} />;
  if (lowerCaseDescription.includes('status'))
    return <AssignmentTurnedInIcon sx={{ color: '#c22027' }} />;
  if (lowerCaseDescription.includes('comment'))
    return <CommentIcon sx={{ color: '#c22027' }} />;
  if (lowerCaseDescription.includes('order'))
    return <LocalShippingIcon sx={{ color: '#c22027' }} />;
  if (lowerCaseDescription.includes('invoice'))
    return <ReceiptIcon sx={{ color: '#c22027' }} />;
  return null; // Default case if no keywords match
};

const OmsLogs: React.FC<OmsLogsProps> = ({ logsData }) => {
  const [showAll, setShowAll] = React.useState(false);
  const displayedLogs = showAll ? logsData : logsData.slice(0, 2);

  return (
    <Box p={2}>
      {displayedLogs.map((log: any) => (
        <Box
          key={log._id}
          sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}>
              {getIconForDescription(log.description)}
              {/* Icon based on description */}
              <Typography variant="body2" fontWeight={700}>
                {log.description} by {log.createdBy.name || 'Unknown'}
              </Typography>
              {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src={
                    log?.createdBy?.avatar ??
                    '/static/it22-website-black-logo.svg'
                  }
                  alt="Avatar"
                  style={{
                    width: 25,
                    height: 25,
                    borderRadius: '50%',
                    objectFit: 'contain',
                    marginRight: 4,
                  }}
                />
                <Typography variant="body2">
                  {log.createdBy.name || 'Unknown'}
                </Typography>
              </Box> */}
            </Box>

            <Typography variant="body2">
              {moment(log.createdAt).format('DD/MMM/YYYY - hh:mm A')}
            </Typography>
          </Box>
          {log.changeFrom && log.changeTo && (
            <div>
              <span>{log.changeFrom}</span> → <span>{log.changeTo}</span>
            </div>
          )}
        </Box>
      ))}

      {logsData.length > 2 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
          <Button variant="text" onClick={() => setShowAll(!showAll)}>
            {showAll ? 'Show Less' : `View More (${logsData.length - 2})`}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default OmsLogs;
